import React, { useState, useRef, useEffect } from 'react';
import MembersTable from './MembersTable';
import LinearProgressWithLabel from './ui/progress';
import { AnsweredQuestions, Cohort, Member } from '@/utils/types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InviteMember from './InviteMember';
import ImportGroup from './ImportGroup';

interface MembersScreenProps {
    cohorts: Cohort[],
    inviteMembers: (members: Member[]) => void
    deleteMembers: (members: Member[]) => void
    remindMembers: (members: Member[]) => void
    memberSelected: (member: Member | null) => void
    error: boolean
    setoverlayComp: (val: boolean) => void
    setResultOverlayComp: (text: string | null) => void
}

export default function MembersScreen(props: MembersScreenProps) {
    const [contentType, setcontentType] = useState<string>("MEMBERS");
    const [members, setmembers] = useState<Member[]>([]);

    const licensesAssigned: number = props.cohorts.reduce((acc, obj) => acc + (obj.members.filter(x => x.membershipType === "student").length || 0), 0);
    const totalLicenses: number = props.cohorts.reduce((acc, obj) => acc + (obj.totalLicenses || 0), 0);

    useEffect(() => {
        const mems = props.cohorts.map(c => c.members).reduce((acc, curr) => acc.concat(curr), []);
        setmembers(mems);
    }, [props.cohorts]);

    return (
        <div className='flex-col items-start justify-start'>
            <div className='flex-col items-start justify-start w-[100%]'>
                {contentType !== "MEMBERS" && <div onClick={() => { setcontentType("MEMBERS") }} className="flex hover:underline cursor-pointer">
                    <ArrowBackIcon />
                    <p className="text-grayBlue mb-2">Back to all Members</p>
                </div>}
                <p className="text-grayBlue text-4xl mb-2 font-[600]">Members</p>
                <div className="flex justify-between  w-[100%]">
                    <p className='text-left w-[60%]'>This page allows admins to see all members, and add additional members.</p>
                    {contentType === "MEMBERS" && licensesAssigned !== totalLicenses && <div className='flex justify-between gap-2'>
                        <div className='px-3 py-2 cursor-pointer hover:bg-whiteButton-hover font-[300] bg-whiteButton rounded-md shadow-sm' onClick={() => setcontentType("IMPORTGROUP")}><p>Import Group</p></div>
                        <div className='px-3 py-2 text-white cursor-pointer hover:bg-grayBlue-hover font-[300] bg-grayBlue rounded-md shadow-sm' onClick={() => setcontentType("INVITE")}><p>Invite New Member</p></div>
                    </div>}
                </div>
            </div >

            <div className="flex-col shadow-sm mt-5 mb-5 p-2 bg-white w-[100%]">
                <div className="flex justify-between items-center w-[100%]">
                    <div className="w-[65%] ml-2">
                        <LinearProgressWithLabel title={`You have ${licensesAssigned} student ${licensesAssigned === 1 ? 'license' : 'licenses'} assigned.`} value={(licensesAssigned / totalLicenses) * 100} label={`${licensesAssigned}/${totalLicenses}`} />
                    </div>
                    {contentType === "MEMBERS" && <div className='px-3 py-2 text-orange-500 cursor-pointer hover:bg-whiteButton-hover font-[300] bg-whiteButton border !border-orange-500 rounded-lg shadow-sm' onClick={() => window.location.href = 'mailto:info@thedevdifference.com?subject=Update%Plan'}><p>Upgrade Plan</p></div>}
                </div>
                <p className="self-start text-left text-customBlack ml-3 mt-2">{`Your current plan allows for ${totalLicenses} student licenses. To add more licenses, upgrade your plan.`}</p>
            </div>
            {contentType === "MEMBERS" && <MembersTable
                members={members}
                deleteMembers={props.deleteMembers}
                remindMembers={props.remindMembers}
                memberSelected={props.memberSelected}
                error={props.error}
                setoverlayComp={props.setoverlayComp} />}
            {contentType === "IMPORTGROUP" && <ImportGroup
                members={members}
                inviteMembers={props.inviteMembers}
                error={props.error}
                setoverlayComp={props.setoverlayComp}
                backToMembers={() => { setcontentType("MEMBERS") }} 
                setResultOverlayComp={props.setResultOverlayComp}
                licensesRemaining = {totalLicenses-licensesAssigned}/>}
            {contentType === "INVITE" && <InviteMember
                members={members}
                inviteMembers={props.inviteMembers}
                error={props.error}
                setoverlayComp={props.setoverlayComp}
                setResultOverlayComp={props.setResultOverlayComp}
                backToMembers={() => { setcontentType("MEMBERS") }} />}
        </div>
    );
}